<template>
  <v-layout justify-center align-center>
    <v-layout v-show="!confirmSend" wrap column class="cv-send-popup-wrap">
      <v-layout mb-1>
        <v-flex>
          <v-flex class="text-right mob-view">
            <v-btn color="primary  " class="pa-0" text @click="closePopup">
              <v-icon class="display-m-30">mdi-arrow-right</v-icon>
            </v-btn>
          </v-flex>

          <v-flex>
            <p class="display-18 mb-1">{{ cvPopup.applyToJob }}</p>

            <ul class="pa-0 mr-12">
              <li
                v-for="(job, index) in jobsDetails"
                :key="index"
                class="display-16 primary--text"
              >
                <span v-if="job">{{ job.JobContent.Name }}</span>
              </li>
            </ul>
          </v-flex>
        </v-flex>
        <v-flex class="text-left x-close pc-view">
          <v-btn color="primary large" text @click="closePopup">
            <v-icon class="icon-forma-1-2 display-16" />
          </v-btn>
        </v-flex>
      </v-layout>
      <CVFiles v-show="currUser" @fileChosen="handleChosenFile" />
      <Spinner v-show="!currUser" />
      <CVDetails
        v-show="currUser"
        ref="details"
        :is-complete-details="isComplete"
        @enableSendCV="handleEnableSendCV"
      />

      <v-flex
        v-show="currUser"
        class="content-block txtarea"
        pt-4
        pb-4
        pl-4
        pr-4
      >
        <p class="mb-2">
          <span
            class="primary--text display-24 pointer"
            @click="toggleLetterField"
          >
            {{ plusSign }}
          </span>
          <span
            class="display-18 d-inline pr-2 pointer"
            @click="toggleLetterField"
          >
            {{ cvPopup.addPersonalLetter }}
          </span>
        </p>
        <v-textarea
          v-if="displayLetter"
          solo
          placeholder="הכנס לכאן מכתב מקדים..."
          v-model="PreliminaryLetter"
        />
      </v-flex>
      <v-flex v-show="currUser" pb-4 pl-4 pr-2>
        <SendToSimilarJobs
          v-if="showSimilarJobsCheckBox"
          @sendToSimilarJobs="sendToSimilar"
        />
      </v-flex>

      <v-flex v-if="!enableSend" v-show="currUser" mt-2 mb-1 pl-4 pr-4>
        <small class="red--text">
          <strong>{{ cvPopup.isCompleteDetails }}</strong>
        </small>
      </v-flex>

      <v-flex v-show="msgError" mt-2 mb-1 pl-4 pr-4>
        <small class="red--text">
          <strong>{{ msgError }}</strong>
        </small>
      </v-flex>

      <v-flex xs12 text-center class="flex-basis-auto" py-3>
        <v-btn
          id="submitApplyAll"
          class="orange_btn_narrow"
          :loading="inProgress"
          :disabled="!file || !enableSend"
          @click="sendDetailsUpdate"
        >
          הגש מועמדות
        </v-btn>
      </v-flex>
    </v-layout>

    <v-flex class="text-left x-close" v-show="confirmSend">
      <v-btn color="primary large" text @click="closePopupSuccess()">
        <v-icon class="icon-forma-1-2 display-16"></v-icon>
      </v-btn>
    </v-flex>

    <v-row
      v-show="confirmSend"
      justify-center
      align-center
      d-flex
      light
      id="confirmSend"
    >
      <v-layout justify-center align-center>
        <v-flex v-if="successfulSend" mt-2>
          <v-flex text-center mb-4>
            <v-icon id="twofin" class="d-block mb-1 ml-6" color="primary">
              icon-fingers
            </v-icon>
          </v-flex>

          <h3 class="display-24 mr-3 mb-3 underline">
            <strong>קורות חיים נשלחו בהצלחה למשרה</strong>
          </h3>

          <ul class="pa-0 mr-5">
            <li
              class="display-16 primary--text mb-1 list-style-none"
              v-for="(job, index) in successfulSend"
              :key="index"
            >
              {{ job.JobTitle }}
            </li>
          </ul>
        </v-flex>

        <v-flex v-if="FailedSend">
          <h3 class="display-24 mr-3 mb-3 underline">
            <strong>קורות חיים לא נשלחו למשרות:</strong>
          </h3>
          <ul class="pa-0 mr-12">
            <li
              v-for="(job, index) in FailedSend"
              :key="index"
              class="display-16 primary--text"
            >
              {{ job.JobTitle }}
            </li>
          </ul>
        </v-flex>
      </v-layout>
    </v-row>
  </v-layout>
</template>

<script>
                        import drushim_lodash from 'lodash';
import { t } from '@/store/modules/homeDrushim/constantsContent';
import CVDetails from '@/components/Dialogs/CV_Popup/CVDetails';
import CVFiles from '@/components/Dialogs/CV_Popup/CVFiles';
import SendToSimilarJobs from '@/components/Forms/Form_Fields/SendToSimilarJobs';
import Spinner from '@/components/Spinner/Spinner';
import gtm from '@/lib/gtm';
import CurrentUser from '@/components/mixins/CurrentUser';
import { SEND_MULTIPLE_CV } from '@/lib/api.js';

export default {
  mixins: [CurrentUser],
  components: {
    CVFiles,
    CVDetails,
    SendToSimilarJobs,
    Spinner,
  },

  props: {
    jobsDetails: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

  data() {
    return {
      cvPopup: t('titles.CV_Popup'),
      inProgress: false,
      file: '',
      displayLetter: false,
      sendingDate: undefined,
      plusSign: '+',
      enableSend: false,
      showSimilarJobsCheckBox: true,
      jobCodes: null,
      confirmSend: false,
      successfulSend: null,
      FailedSend: null,
      msgError: null,
      ssaData: null,
      goal8: null,
      PreliminaryLetter: '',
    };
  },

  computed: {
    ssa() {
      return drushim_lodash.get(this.$ssa, 'vm', {});
    },

    isSendDisabled() {
      let res = false;
      if (!this.file) {
        res = true;
      }
      if (!this.enableSend) {
        res = true;
      }
      return res;
    },

    currUser() {
      return this.CurrentUser;
    },

    isComplete() {
      // return this.CurrentUser && this.CurrentUser.Profile
      //   ? this.CurrentUser.Profile.IsComplete
      //   : false;
      return (
        this.CurrentUser &&
        this.CurrentUser.Profile &&
        this.CurrentUser.Profile.IsComplete &&
        /[0][5]\d{8}$/.test(this.CurrentUser.Profile.Phone)
      );
    },
  },
  watch: {
    isComplete() {
      this.enableSend = this.isComplete;
    },
  },

  mounted() {
    this.successfulSend = false;
    this.fetchUserProfile();
    this.sendEnable();
  },

  methods: {
    sendSSA(evenData) {
      this.ssa.logResponse('LogSSA', evenData);
    },
    sendToSimilar(val) {
      /**
       * @param {Boolean} val , value form SendToSimilarJobs
       * emit to CVUserDetailsEdit
       */
      this.$nuxt.$emit('sendToSimilar', val);
    },
    sendEnable() {
      this.enableSend = this.isComplete;
      console.log(this.isComplete);
      console.log('enable send', this.enableSend);
    },

    handleEnableSendCV(val) {
      console.log('handleEnableSendCV', val);
      this.enableSend = val;
      console.log('handleEnableSendCV', this.enableSend);
    },

    // move to outside common function
    async fetchUserProfile() {
      await this.$auth.fetchUser();

      /**
       * @param {null} showSimilarJobsCheckBox showSimilarJobsCheckBox checkbox if  is null only
       */
      this.showSimilarJobsCheckBox =
        this.currUser.Profile.SendToSimilarJobs === null;

      this.sendEnable();
    },

    // send update user details
    async sendDetailsUpdate() {
      try {
        const { error, valid } = await this.saveDetails();
        if (!error && valid) {
          await this.sendCV();
        } else if (error) {
          throw error;
        }
      } catch (e) {
        console.error('sendDetailsUpdate', e);
      }
    },

    saveDetails() {
      return this.$refs.details.saveDetails();
    },

    getJobsCodes() {
      const jobsCodes = drushim_lodash.toString(drushim_lodash.map(this.jobsDetails, 'Code'));
      return jobsCodes;
    },

    async sendCV() {
      const temJobCodes = this.getJobsCodes();
      let { query } = this.$route;
      let { sag, tid, ac, platinum } = query;
      let platinumParam = platinum ? `&platinum=${platinum}` : '';

      if (this.file) {
        this.inProgress = true;

        // let user_sParam = this.$route.query.user_s ? `&user_s=real_new` : '';

        let postdata = {
          Index: 0,
          PreliminaryLetter: this.PreliminaryLetter,
          ...(sag && { SmartAgentGroup: sag }),
          ...(tid && { TestId: tid }),
          ...(ac && { AgentCode: ac }),
        };

        await this.$axios
          .post(
            `${SEND_MULTIPLE_CV}?JobCode=${temJobCodes}&cvc=${this.file.Code}${platinumParam}`,
            postdata
          )
          .then((res) => {
            if (res.data.IsError) {
              /**
               * get the first key value
               */
              let value = Object.keys(res.data.Errors)[0];
              throw value;
            }
            if (res.data.Successful.length > 0) {
              this.ssaData = res.data.SSAEvents;
              this.sendSSA(this.ssaData);
            }

            if (res.data.Failed.length > 0) {
              this.alertFailed(res.data.Failed[0].JobCode);
              this.inProgress = false;
              throw res.data.Failed;
            }

            this.successfulSend = !drushim_lodash.isEmpty(res.data.Successful)
              ? res.data.Successful
              : false;
            this.FailedSend = !drushim_lodash.isEmpty(res.data.Failed)
              ? res.data.Failed
              : false;

            this.goal8 =
              res.data.QueryParams.Goal8.length > -1
                ? res.data.QueryParams.Goal8
                : false;
          })
          .then(() => {
            this.inProgress = false;

            this.confirmSend = true;
            this.dialogMaxWidth = 500;

            this.fetchUserProfile();
            this.fireGtm();
          })
          .catch((e) => {
            switch (e) {
              case 'ExceededDailyCvSubmissionsLimit':
                this.msgError =
                  'הגעת למכסת השליחות היומית שלך. אנא נסה לשלוח שוב מחר!';
                this.inProgress = false;
                break;
              default:
                this.msgError = 'שגיאת שליחה';
                this.inProgress = false;
                break;
            }
          });
      }
    },
    fireGtm() {
      if (this.goal8)
        gtm({
          event: this.goal8,
        });
      this.jobsDetails.forEach((job) => {
        gtm({
          event: 'send_all_cv_multiple',
          'gtm.uniqueEventId': job.Code,
          gaCategory: 'event_multiple',
          gaAction: 'complete',
          gaLabel: 'all_send_cv',
          send: 'multiple',
        });

        // send_all_cv
        gtm({
          event: 'send_all_cv',
          'gtm.uniqueEventId': job.Code,
          gaCategory: 'event',
          gaAction: 'complete',
          gaLabel: 'all_send_cv',
          send: 'multiple',
        });

        let transactionDataLayer = {
          event: 'transaction',
          ecommerce: {
            purchase: {
              actionField: {
                id: drushim_lodash.get(job.JobAnalytics, 'TransactionId'),
                affiliation: 'drushim',
                ...drushim_lodash.pick(job.JobAnalytics, ['revenue', 'tax', 'shipping']),
              },
              products: [
                drushim_lodash.pick(job.JobAnalytics, [
                  'name',
                  'id',
                  'price',
                  'brand',
                  'category',
                  'variant',
                  'quantity',
                  // 'coupon',
                ]),
              ],
            },
          },
          'gtm.uniqueEventId': 2282,
        };
        gtm(transactionDataLayer);
      });
    },

    handleChosenFile(file) {
      this.file = file;
    },

    closePopup() {
      this.confirmSend = false;
      this.$nuxt.$emit('closeBasketDialog');
    },
    closePopupSuccess() {
      this.confirmSend = false;
      this.$nuxt.$emit('closeBasketDialog');
    },
    toggleLetterField() {
      this.displayLetter = !this.displayLetter;
      this.plusSign = this.displayLetter ? '-' : '+';
    },

    /**
     * * @jobCode { number }
     * emiting to CVDialog that sent cv not succeded
     */
    alertFailed(jobCode) {
      this.$nuxt.$emit('alertCVSendFailed', jobCode);
    },
  },
};
</script>

<style lang="scss" scoped>
.content-block {
  border-radius: 5px;
  background-color: #f6f7f9;
  margin: 5px;
}

.cv-send-popup-wrap {
  object-fit: contain;
  border-radius: 20px;
}

.align-vertical {
  margin-bottom: 20px;
}

#twofin {
  font-size: 50px;
}
.success-send {
  margin-top: 20%;
  text-align: center;
}
#confirmSend {
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  padding: 10px;
}
@media screen and (min-width: 600px) {
  #confirmSend {
    position: relative;
    top: 0;
    -ms-transform: initial;
    transform: initial;
  }
  .success-send {
    margin-top: 0;
  }
  .content-block {
    margin: 10px;
  }

  #twofin {
    font-size: 50px;
    margin-bottom: 20px;
  }
}

@media screen and (max-width: 900px) {
  .cv-send-popup-wrap {
    padding: 0 10px;
  }
}
</style>
